import type { IWidgetConfig } from "../shared/session/interfaces/session";

export function isPayoutEditable(
  config: Pick<IWidgetConfig, "allowPayoutEdit"> | undefined,
): boolean {
  return config?.allowPayoutEdit === true;
}

export function isDestinationCurrencyEditable(
  config:
    | Pick<
        IWidgetConfig,
        "allowPayoutEdit" | "allowDestinationCurrencyEdit"
      >
    | undefined,
): boolean {
  if (config?.allowDestinationCurrencyEdit === true) return true;
  if (config?.allowDestinationCurrencyEdit === false) return false;
  return config?.allowPayoutEdit === true;
}
